export default __webpack_public_path__ + "static/media/0x8f18dc399594b451eda8c5da02d0563c0b2d0f16.27a417b3.png";